export default angular.module('eventix.common.directives.clearInput', [])
    .directive('clearInput', function($compile) {
        /**
         * @ngdoc directive
         * @name eventix.common.directives:clearInput
         * @restrict attribute
         * @description
         * Add a clear button to an input element to easily clear an input field
         *
         * @example
         * ```
         * <input type="text" ng-model="$ctrl.inputValue" clear-input>
         * ```
         */
        return {
            restrict: 'A',
            priority: 1000,
            link: function(scope, el) {
                let clearAttr = /(input|select)/i.test(el[0].tagName) ? 'value' : 'innerText';

                scope.clearInput = clearInput;

                let icon = angular.element('<a uib-tooltip="Clear" ng-click="clearInput()" style="color: #afafaf;"><i class="fa fa-times mouse-pointer"></i></a>');

                let offsetRight = _.sum(_.map(el.css(['marginRight', 'borderRightWidth']), parseFloat));
                let offsetTop = _.sum(_.map(el.css(['marginTop', 'borderTopWidth']), parseFloat));

                icon.css({
                    position: 'absolute',
                    right: (offsetRight + 7) + 'px',
                    top: (offsetTop + 7) + 'px',
                    zIndex: 999
                });

                el.removeAttr('clear-input');

                let newParent = angular.element('<div style="position: relative;"></div>');
                newParent.append($compile(icon)(scope));
                newParent.insertBefore(el);

                el.appendTo(newParent);

                function clearInput() {
                    if (clearAttr === 'value')
                        el.val('');
                    else
                        el.text('');

                    // Angular's ng-change does not fire/listen without explicitly triggering it.
                    el.triggerHandler('change');
                }
            }
        };
    }).name;
